// extracted by css-extract-rspack-plugin
export default {"area":"pC2Bs","bar":"cGxus","tab":"iSSXm","active":"YcL0J","label":"WLW4A","sqlPreviewDropdown":"dIfcK","sqlPreview":"pe6H8","sqlPreviewHeader":"EVJXV","sqlEditor":"kMFz9"};